import type {FC} from 'react';
import {observer} from 'mobx-react';
import {MultiSelect} from '@wellstone-solutions/web';
import type {UICollectionType} from '@wellstone-solutions/common/models/rest';
import {useStores} from 'hooks/useStores';

interface CollectionSelectProps {
  value: UICollectionType[];
  onChange: (collections: UICollectionType[]) => void;
}

// Categories a resource belongs to. Collections are already loaded into
// `resourceStoreV2` for the member-facing filter list, so this reuses them
// rather than fetching its own copy.
export const CollectionSelect: FC<CollectionSelectProps> = observer(
  ({value = [], onChange}) => {
    const {resourceStoreV2} = useStores();
    const collections: UICollectionType[] = resourceStoreV2.collections;

    return (
      <MultiSelect
        fieldName="collections"
        label="Categories"
        items={collections.map(({id, name}) => ({value: id, label: name}))}
        value={value.map(({id}) => id)}
        onChange={(ids) =>
          onChange(collections.filter(({id}) => ids.includes(id)))
        }
      />
    );
  },
);
